import AerosolBlock from "../components/blocks/AerosolBlock";

const AerosolOverview = () =>
{

    return (<>
        <AerosolBlock/>
    </>)
}
export default AerosolOverview